export const ANALYTICS_PAGE = 'analyticsPage';
export const LISTING_SOURCES_PATH = '/sources';
export const EXPERIMENTS_PATH = '/experiments';
export const FILE_PROXY_PATH = 'rental-manager/file-proxy';
export const LISTING_CLAIMING_PATH = '/listing-claiming';
export const INVOICE_PAYMENTS = 'invoicepayments';
export const USER_MANAGEMENT_PAGE = 'userManagementPage';
export const USER_MANAGEMENT_APPLICATION_PERMISSION_PAGE = 'userManagementApplicationPermissionPage';
export const PDP_PAYMENTS = 'pdpPayments';
export const PDP_APPLICATIONS = 'pdpApplications';
export const PROXY_PATH = 'rental-manager/proxy';
export const RENT_GUARANTEE_PATH = 'rent-guarantee';
export const RENT_GUARANTEE_ENROLL_PATH = 'rental-manager/rental-protection/enroll';
export const RENTAL_GROWTH_API_V1_PREFIX = 'rental-growth-api/api/v1';
export const RENTAL_GROWTH_GRAPHQL_API_V1_PREFIX = 'rental-growth-api/api/graphql/v1';
export const RENTAL_GROWTH_PROXY_PATH = 'rental-manager/growth/growth-proxy';
export const RENTAL_MANAGER_API_V1_PREFIX = 'rental-manager-api/api/v1';
export const RENTAL_MANAGER_API_V2_PREFIX = 'rental-manager-api/api/v2';
export const SETTINGS_PAGE = 'rental-manager-api/settings';
export const ID_VERIFICATION_PAGE = 'id-verification';
export const CREATE_LISTING_PAGE = 'create-listing';
export const PREMIUM_ANALYTICS = 'premium-analytics';
export const LISTING = 'listing';
